import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  errorList: {
    lineHeight: 2,
    fontSize: theme.spacing(2),
    margin: theme.spacing(0, 1),
  },
}))

export default useStyles
